import { z } from 'zod';

/** One or more dot-separated labels then a final label; unanchored, as the form has always matched it. */
const DOMAIN_PATTERN = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/;

/** The domain setup form's rules: a domain name and a site type. */
export const domainSchema = z.object({
  domain: z
    .string()
    .min(1, 'Enter the domain name.')
    .regex(DOMAIN_PATTERN, 'Enter a valid domain name, like example.com.'),
  baySelect: z.string().min(1, 'Choose a site type.'),
});
